import React from 'react'
import AimdFlowQuestionBase from '../../components/aimdFlowQuestionBase'
import { Box, Button, Stack, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'

//we will show this page to user to decide wether adit existing details or start scan 


const commonCssForutton = {
    height: '58px',
    flexShrink: 0,
    borderRadius: '40px',
    textAlign: 'center',
    fontSize: '18px',
    minWidth: '300px',
    fontWeight: 500,
    margin: "20px",

}


const EditOrScanPage = () => {
    const navigate = useNavigate();

    const onProceedToScanHandler = () => {
        navigate('/pre-face-scan',{
            state: { isComingFromProceedScanPage : true }
        });
    }

    return (
        <>
            <AimdFlowQuestionBase
                IsShowBackIcon={false}
                isShowMenuIcon={true}
                isShowStepper={false}
            >
                <Box>
                    <Typography sx={{
                        fontSize: { lg: "50px", xs: "40px" },
                        fontWeight: 400,
                        textAlign: "center"
                    }}>
                        Welcome Back!
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { lg: "24px" },
                            textAlign: "center",
                            margin: "16px 16px 20px 16px"
                        }}
                    >
                        Would you like to update your details or continue to the face scan?
                    </Typography>
                    <Box sx={{
                        display: "flex",
                        justifyContent: 'center',
                        flexWrap: "wrap"
                    }}>
                        <Link to="/demographics">
                            <Button sx={{
                                border: "2px solid #72d8da",
                                backgroundColor: "white",
                                color: "#72d8da",

                                ...commonCssForutton

                            }}>Update My Details
                            </Button>
                        </Link>

                            <Button 
                            onClick={onProceedToScanHandler}
                            sx={{

                                background: 'linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%)',
                                boxShadow: '0px 35px 35px 0px rgba(0, 0, 0, 0.09), 0px 9px 19px 0px rgba(0, 0, 0, 0.1)',
                                color: '#fff',

                                ...commonCssForutton

                            }} >
                                
                                Proceed to Scan
                            </Button>
                    </Box>


                </Box>

            </AimdFlowQuestionBase>
        </>
    )
}

export default EditOrScanPage